export const OPACITIES = {
  FULL: 1,
  HIGHLIGHTED: 0.7,
  NEW_ZONE: 0.95,
  DEFAULT: 0.4,
  FADED: 0.1,
  INVISIBLE: 0,
};
